module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_locked.a73b7cbc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_locked.png
// module id = 1045
// module chunks = 16